import React from 'react';
import { describePrizeSplit, prizeSplitInputProblem } from '../../utils/helper/prizeSplit';

/**
 * The running total of an auction's prize split, shown on Create Auction and in the Update Auction
 * modal (#146): what has been allocated, and what is left or by how much it is over. A field
 * holding something unusable is named instead; a field still empty is not flagged.
 *
 * Divs rather than paragraphs: ModalBox (Outer/Modal.js) wraps the modal's whole body in a <p>.
 *
 * @param {{summary: Object, placeLabels: string[]}} props summary from summarizePrizeSplit, and
 *   the places' titles for naming a bad field.
 */
export const PrizeSplitTotal = ({ summary, placeLabels }) => {
  const { allocated, balance } = describePrizeSplit(summary);
  const inputProblem = prizeSplitInputProblem(summary, placeLabels);

  const balanceClass =
    inputProblem || summary.status === 'over'
      ? 'err-message mt-0'
      : summary.status === 'exact'
        ? 'text-success'
        : '';

  return (
    <div className="mb-3" aria-live="polite">
      <div>{allocated}</div>
      <div className={balanceClass}>{inputProblem || balance}</div>
    </div>
  );
};
